export default (Vue) => {
  // Header Loading page
  Vue.component('loading-page-header', () => import('./header'))

  // Footer Loading Page
  Vue.component('loading-page-footer', () => import('./footer'))
}



// WEBPACK FOOTER //
// ./src/components/loading-page/index.js